s = window.s || {};
s.dom = s.dom || {};

s.tpl = $.extend(s.tpl, {
	playerOnline: '<div id="jp-instance" style="display:none;"></div>',
});

$(function(){
	var $holder = s.dom.$body.find("#jp-container");
	
	function load(link, release, guest) {
		return $.ajax({
			url: link,
			type: "GET",
			async: true,
			cache: true,
			dataType: "json"
		}).done(function(data) {
			s.player.setData(data, release, guest);
		}).fail(function(jqXHR, textStatus, errorThrown){
			if (textStatus !== "abort" && jqXHR.readyState > 0) {
				var message = "Не удалось выполнить запрос";
				var title = "Ошибка";
	
				if (jqXHR.status == 404) {
					message = "Запрашиваемая страница не найдена";
					title = "404 ошибка";
				}
				if (textStatus === "error") {
					message = "[" + jqXHR.status + "] " + message + "\r\n" + errorThrown;
				}
				
				s.showError(message, title);
			}
		});
	};
	
	function setControlsSize() {
		var $timeLineHolder = $holder.find(".time-line-holder");
		var $artistHolder = $holder.find(".artist-holder");
		
		if (s.tabletFix.is(':hidden') && s.mobileFix.is(':hidden')){
			$timeLineHolder
				.insertAfter($holder.find(".playing-service"));
			$artistHolder
				.insertBefore($holder.find(".track-list-holder"));
		}
		if (s.tabletFix.is(':visible') && s.mobileFix.is(':hidden')){
			$timeLineHolder
				.appendTo($holder.find(".playing-service"));
			$artistHolder
				.insertBefore($holder.find(".buttons"));
		}
		if (s.tabletFix.is(':hidden') && s.mobileFix.is(':visible')){
			$artistHolder
				.insertBefore($holder.find(".buttons"));
			$timeLineHolder
				.insertBefore($artistHolder);
		}
	};
	
	setControlsSize();
	s.dom.$window.resize(function(){
		setControlsSize();
	});
	
	s.player.init("#jp-instance", {
		callback: function (){
			s.dom.$main.on("click", ".js-player", function(e){
				e.preventDefault();
				e.stopPropagation();
				var $this = $(this);
				if ($this.hasClass("pause")) {
					s.player.pause();
				} else {
					s.player.first_play();

					var deferred = load($this.data("src"), $this.data("release"), $this.data("guest"));
					deferred.done(function(){
						s.player.play();
					});
				}
			});
			
			$holder.find("#jp-prev").on("click", function(e){
				e.preventDefault();
				e.stopPropagation();
				s.player.prev();
				s.player.play();
				s.player.preload();
			});
			$holder.find("#jp-next").on("click", function(e){
				e.preventDefault();
				e.stopPropagation();
				s.player.next();
				s.player.play();
				s.player.preload();
			});
			
			var $volumeHolder = $holder.find("#jp-volume-holder");
			$volumeHolder.find(".btn-volume").on("click", function(e){
				e.preventDefault();
				e.stopPropagation();
				
				if ($volumeHolder.hasClass("mute")) {
					$volumeHolder.removeClass("mute");
					s.player.mute(false);
				} else {
					$volumeHolder.addClass("mute");
					s.player.mute(true);
				}
			});
			
			var $playerPanel = $holder.closest(".player-panel");
			$holder.find("#jp-tracklist").on("click", function(e){
				e.preventDefault();
				e.stopPropagation();
				
				var $this = $(this);
				if (s.popup.cache.length) {
					s.popup.closeAll();
				} else {
					s.popup.load("#tpl_tracklist", function($popup){
						s.dom.$header.removeClass('fixed');
						var timeoutID = null;
						s.dom.$window.on("resize.page", function(){
							if (timeoutID) {
								clearTimeout(timeoutID);
							}
							$popup.css('height', $(document).height());
							
							var popupMaxHeight = $(window).height() - $playerPanel.outerHeight();
							popupMaxHeight -= parseInt($popup.find(".popup").css('padding-top').replace("px", ""));
							popupMaxHeight -= parseInt($popup.find(".popup").css('padding-bottom').replace("px", ""));
							
							$popup.find(".scroll-item").css({
								maxHeight: popupMaxHeight
							});
							
							timeoutID = setTimeout(function(){
								s.popup.align($popup, $playerPanel.outerHeight());
							}, 0);
						});
						
						s.popup.closeAll();
						$this.addClass("active");
						$popup.on("popup.close", function(){
							$this.removeClass("active");
							s.dom.$body.attr("style", "");
							s.dom.$html.removeClass('play-list-popup-active');
						});
						
						var popupMaxHeight = $(window).height() - $playerPanel.outerHeight();
						popupMaxHeight -= parseInt($popup.find(".popup").css('padding-top').replace("px", ""));
						popupMaxHeight -= parseInt($popup.find(".popup").css('padding-bottom').replace("px", ""));
						
						$popup.find(".scroll-item").css({
							maxHeight: popupMaxHeight
						});
						
						$popup.find("#js-tracklist-content")
							.html(s.player.current.guest_tracklist);
						
						s.dom.$body.css({
							'overflow': 'hidden'
						});
						
						s.dom.$html.addClass('play-list-popup-active');
						s.popup.show($popup, $playerPanel.outerHeight());
					});
				}
			});
			
			load($holder.data("src"));
			
			var $seekBar = $holder.find("#js-seek-bar");
			var $seekHolder = $seekBar.closest(".time-line-holder");
			var $seekBarCursor = $holder.find("#js-play-bar");
			var seekBarSize = null;
			var seekBarOffset = null;
			var seekPosition = null;
			var seekTimeout = null;
			var seekInited = false;
			
			function _seekSet(posX) {
				seekPosition = (posX - seekBarOffset) / seekBarSize;
				if (seekPosition > 1) {
					seekPosition = 1;
				} else if (seekPosition < 0) {
					seekPosition = 0;
				}
				seekPosition *= 100;
				$seekBarCursor.width(seekPosition+"%");
			};
			function _seekStop(){
				if ( ! seekInited) {
					return;
				}
				
				if (seekTimeout) {
					clearTimeout(seekTimeout);
				}
				seekTimeout = setTimeout(function(){
					s.player.instance.jPlayer("playHead", seekPosition);
				}, 0);
				$seekHolder
					.off("mousemove")
					.off("mouseup")
					.off("touchmove")
					.off("touchend");
				seekInited = false;
			};
			function _seekInit(){
				console.log("init");
				seekBarSize = $seekBar.width();
				seekBarOffset = $seekBar.offset().left;
				
				$seekHolder.on("mousemove", function(e){
					_seekSet(e.pageX);
				});
				$seekHolder.on("mouseup", function(e){
					_seekSet(e.pageX);
					_seekStop();
				});
				$seekHolder.on("touchmove", function(e){
					_seekSet(e.originalEvent.touches[0].pageX);
				});
				$seekHolder.on("touchend", function(){
					_seekStop();
				});
				seekInited = true;
			};
			
			$seekBar.on("mousedown", _seekInit);
			$seekBar.on("touchstart", _seekInit);
			$seekBar.closest(".time-line-holder").on("mouseleave", _seekStop);
			s.player.instance.bind($.jPlayer.event.timeupdate, function(e){
				if ( ! seekInited) {
					$seekBarCursor.width(e.jPlayer.status.currentPercentAbsolute+"%");
				}
			});
		},
		jPlayer: {
			preload: "none",
			cssSelectorAncestor: "#jp-container",
			cssSelector: {
				play: "#jp-play",
				pause: "#jp-pause",
				currentTime: "#jp-current-time",
				duration: "#jp-duration",
				repeat: "#jp-repeat",
				repeatOff: "#jp-repeat-off",
			},
			volume: 0.8
		},
		controls: "#jp-volume-holder"
	});
	
	s.player.instance.on("play", function(){
		if (s.player.release && s.player.guest) {
			var $list = s.dom.$main.find(".js-play-pause");
			$list.removeClass("pause");
			$list.filter("[data-release="+s.player.release+"][data-guest="+s.player.guest+"]")
				.addClass("pause");

			var $list_anons = s.dom.$main.find(".item .js-play-pause");
			$list_anons.filter("[data-release="+s.player.release+"]")
				.addClass("pause");
		}
		s.counters.adwolf.hitAudio();
	});
	s.player.instance.on("pause", function(){
		s.dom.$main.find(".js-play-pause")
			.removeClass("pause");
	});
	s.dom.$window.on("ajax.loaded", function(){
		if (s.player.release && s.player.guest) {
			var $list = s.dom.$main.find(".js-play-pause");
			$list.removeClass("pause");
			$list.filter("[data-release="+s.player.release+"][data-guest="+s.player.guest+"]")
				.addClass("pause");	
		}
	});
	
	s.player.instance.on("change", function(e, data){
		var $marqueeHolder = $holder.find(".artist-holder .artist");

		var html = "<a href=\"" + data.link + "\">" + data.guest_title;
		if (data.release_code) {
			html += " - выпуск #" + data.release_code;
		}
		html += " - " + data.release_date + "</a>";

		$marqueeHolder.marquee("destroy");
		//$marqueeHolder.html("<a href=\""+data.link+"\">"+data.release_title+" ("+data.guest_title+")</a>");
		$marqueeHolder.html(html);
		$marqueeHolder.marquee({
			pauseOnHover: true,
			startVisible: true,
			duplicated: true,
			gap: 70,
			delayBeforeStart: "1000"
		});

		var trackListCountHolder = $holder.find("#js-tracklist-count");
		var trackListCount = parseInt(data.guest_tracklist_count);
		if (trackListCount > 0) {
			trackListCountHolder.text(trackListCount).show();
		} else {
			trackListCountHolder.hide();
		}
	});
	
	s.player.instance.on("preload", function(e, release, guest){
		load($holder.data("src")+"/"+release, release, guest);
	});
	
});